export default __webpack_public_path__ + "static/media/get-delivered.c9c996fa.svg";